"use strict";

exports.__esModule = true;
exports["default"] = exports.VideoWrapper = exports.VideoContainer = exports.Video = exports.HtmlBrightcove = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

var _excluded = ["videoThumbnail"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VideoContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "brightcove__VideoContainer",
  componentId: "sc-1bytu3t-0"
})(["position:relative;overflow:hidden;border-radius:12px;"]);
exports.VideoContainer = VideoContainer;
var VideoWrapper = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "brightcove__VideoWrapper",
  componentId: "sc-1bytu3t-1"
})(["padding-bottom:56.25%;position:relative;z-index:1;margin-bottom:1.5em;margin-top:1em;margin:0;"]);
exports.VideoWrapper = VideoWrapper;

var Video = _styledComponents["default"].video.withConfig({
  displayName: "brightcove__Video",
  componentId: "sc-1bytu3t-2"
})(["display:block;height:100%;left:0;position:absolute;top:0;width:100%;"]);

exports.Video = Video;
var VideoThumb = (0, _styledComponents["default"])(function (_ref) {
  var videoThumbnail = _ref.videoThumbnail,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "brightcove__VideoThumb",
  componentId: "sc-1bytu3t-3"
})(["background-image:url(", ");background-size:cover;position:absolute;top:0;left:0;z-index:1;"], function (_ref2) {
  var videoThumbnail = _ref2.videoThumbnail;
  return videoThumbnail;
});
var VideoInfo = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "brightcove__VideoInfo",
  componentId: "sc-1bytu3t-4"
})(["background-color:", ";color:", ";fill:", ";position:absolute;top:0;left:0;cursor:pointer;z-index:1;"], function (props) {
  return (0, _styles.themeTransparentize)(0.4, "shadow", props);
}, function (props) {
  return (0, _styles.colors)("icon-light", props);
}, function (props) {
  return (0, _styles.colors)("icon-light", props);
});
var DateTimeText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "brightcove__DateTimeText",
  componentId: "sc-1bytu3t-5"
})(["letter-spacing:2.3px;"]);
var titleFont = {
  color: "text-light",
  fontSize: 5,
  fontWeight: 2,
  lineHeight: 2,
  mb: [2, 2, 4],
  tag: "h3",
  textAlign: "left"
};
var timeFont = {
  color: "text-light",
  fontSize: 2,
  fontWeight: 1,
  lineHeight: 2,
  tag: "p",
  textAlign: "left"
};
var propTypes = {
  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** formatted datetime */
  dateTime: _propTypes.string,

  /** onClick handler for video container */
  onClick: _propTypes.func,

  /** boolean to show info */
  showInfo: _propTypes.bool,

  /** title text */
  title: _propTypes.string,

  /** video player component */
  videoPlayer: _propTypes.node,

  /** video thumbnail image url */
  videoThumbnail: _propTypes.string
};
var defaultProps = {
  showInfo: true
};

var HtmlBrightcove = function HtmlBrightcove(_ref3) {
  var dataTestId = _ref3["data-test-id"],
      dateTime = _ref3.dateTime,
      onClick = _ref3.onClick,
      showInfo = _ref3.showInfo,
      title = _ref3.title,
      videoPlayer = _ref3.videoPlayer,
      videoThumbnail = _ref3.videoThumbnail;
  return /*#__PURE__*/_react["default"].createElement(VideoContainer, {
    "data-test-id": dataTestId,
    my: 4,
    px: ["4px", 1, "12px", "12px", 2, 2]
  }, /*#__PURE__*/_react["default"].createElement(VideoWrapper, null, showInfo && /*#__PURE__*/_react["default"].createElement(VideoThumb, {
    height: 1,
    videoThumbnail: videoThumbnail,
    width: 1
  }), showInfo && /*#__PURE__*/_react["default"].createElement(VideoInfo, {
    alignItems: "flex-start",
    flexDirection: "column",
    height: 1,
    justifyContent: "flex-end",
    onClick: onClick,
    p: [2, 2, 5],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    height: [48, 48, 70],
    mb: [2, 2, 5],
    width: [48, 48, 70]
  }, /*#__PURE__*/_react["default"].createElement(_components.AVPlayAlt, {
    height: "100%",
    width: "100%"
  })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, titleFont, title), /*#__PURE__*/_react["default"].createElement(DateTimeText, timeFont, dateTime)), videoPlayer));
};

exports.HtmlBrightcove = HtmlBrightcove;
HtmlBrightcove.defaultProps = defaultProps;
HtmlBrightcove.propTypes = propTypes;
HtmlBrightcove.displayName = "Modules.HtmlBrightcove";
var _default = HtmlBrightcove;
exports["default"] = _default;